import { render } from "./UnitTags.vue?vue&type=template&id=000c658d"
import script from "./UnitTags.vue?vue&type=script&lang=js"
export * from "./UnitTags.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__